import { IconAlertTriangle, IconInfoCircle } from "@tabler/icons-react";
import Callout from "../UI/Callout";
import Text from "../UI/Text";
import type { ComptaFinding } from "../../models/comptaFinding";
import styles from "./ComptaChecklist.module.css";

interface ComptaChecklistProps {
  findings?: ComptaFinding[];
}

export default function ComptaChecklist({ findings }: ComptaChecklistProps) {
  if (!findings || findings.length === 0) return null;

  const hasDataFinding = findings.some((finding) => finding.level === "data");

  return (
    <Callout
      variant={hasDataFinding ? "warning" : "info"}
      title="Points de vigilance"
    >
      <div className={styles.list}>
        {findings.map((finding, i) => (
          <div key={`${finding.code}-${i}`} className={styles.item}>
            {finding.level === "data" ? (
              <IconAlertTriangle size={16} />
            ) : (
              <IconInfoCircle size={16} />
            )}
            <Text>{finding.label}</Text>
          </div>
        ))}
      </div>
    </Callout>
  );
}
